import React from 'react';
import styled from 'styled-components';
import { Row, Col } from 'antd';

import { FormTitle, TextInput, Dropdown } from 'components/Core/Forms';
import { isMatchPassportName, isRequireMeetingPoint } from 'utils/product';
import { countries } from 'utils/countries';
import { isRequireHotelName } from 'utils/booking';

const Container = styled.div`

`;

const Note = styled.p`
  margin-bottom: 5px;
`;

const titleOptions = [
  { label: 'Mr.', value: 'Mr.' },
  { label: 'Mrs.', value: 'Mrs.' },
  { label: 'Ms.', value: 'Ms.' }
];

const TravelerInformationForm = props => {
  const { book, product, onChange, meetingPoints } = props;
  const isShowNameTitle = isMatchPassportName(product);
  return (
    <Container>
      <FormTitle>Customer Information</FormTitle>
      {isShowNameTitle && <Note><b>Note:</b> Customer name must match with customer&apos;s passport</Note>}
      <Row gutter={16}>
        {isShowNameTitle && (
          <Col span={5}>
            <Dropdown
              label="Title"
              options={titleOptions}
              onChange={v => onChange('user.nameTitle', v)}
              value={book.user.nameTitle}
            />
          </Col>
        )}
        <Col span={isShowNameTitle ? 19 : 24}>
          <TextInput
            label="Firstname"
            onChange={e => onChange('user.firstName', e.target.value)}
            value={book.user.firstName}
          />
        </Col>
      </Row>
      <TextInput
        label="Lastname"
        onChange={e => onChange('user.lastName', e.target.value)}
        value={book.user.lastName}
      />
      <TextInput
        label="Email"
        onChange={e => onChange('user.email', e.target.value)}
        value={book.user.email}
      />
      <TextInput
        label="Mobile"
        onChange={e => onChange('user.phone', e.target.value)}
        value={book.user.phone}
      />
      <Dropdown
        label="Country of Passport"
        onChange={v => onChange('user.country', v)}
        value={book.user.country}
        options={countries}
        showSearch
        optionFilterProp="children"
        filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
      />
      {isRequireMeetingPoint(product) && !(book.hotelQuantity > 0) &&
        <Dropdown
          label="Meeting Point"
          onChange={v => onChange('user.meetingPoint', v)}
          value={book.user.meetingPoint}
          options={meetingPoints}
          showSearch
          optionFilterProp="children"
          filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
        />
      }
      {isRequireHotelName(book) &&
        <TextInput
          label="Hotel Name"
          onChange={e => {
            onChange('user.hotelName', e.target.value);
            if (book.hotelQuantity > 0) {
              onChange('user.meetingPoint', 'Hotel name');
            }
          }}
          value={book.user.hotelName}
        />
      }
    </Container>
  );
};

export default TravelerInformationForm;



// WEBPACK FOOTER //
// ./src/components/Form/TravelerInformationForm.js